import React from 'react';
import LoginFunctional from './components/login-functional';
import './login.scss';

const Login = () => {
	return <LoginFunctional />;
};

export default Login;
